var map = {
	"./acloudguru.png": 123,
	"./ada.png": 124,
	"./address_image.svg": 125,
	"./animated_logo.svg": 126,
	"./ashurst.png": 127,
	"./asx.png": 128,
	"./asxv2.png": 129,
	"./asxv3.png": 130,
	"./atlassian.png": 131,
	"./atlassianv2.png": 132,
	"./axletree.png": 133,
	"./blogs_image.svg": 134,
	"./businessOne.png": 135,
	"./chocsoc.png": 136,
	"./clayton.png": 137,
	"./cloud_infrastructure.svg": 138,
	"./commstem.png": 139,
	"./contactMail.png": 140,
	"./coursera_logo.png": 141,
	"./data_science.svg": 142,
	"./deeplearning_ai_logo.png": 143,
	"./developerActivity.svg": 144,
	"./education.svg": 145,
	"./experience.svg": 146,
	"./feelingProud.svg": 147,
	"./fullstack.svg": 148,
	"./gcp_logo.png": 149,
	"./github_logo.png": 150,
	"./googleAssistant.jpg": 151,
	"./googleAssistant.svg": 152,
	"./google_logo.png": 153,
	"./headertongyu2.png": 154,
	"./headertongyu3.png": 155,
	"./hsf.png": 156,
	"./hsf.webp": 157,
	"./jsFramework.svg": 158,
	"./law1.png": 159,
	"./law2.png": 160,
	"./law3.png": 161,
	"./law4.png": 162,
	"./manOnTable.svg": 163,
	"./microsoft_logo.png": 164,
	"./nsbhs.png": 165,
	"./nswCusService.png": 166,
	"./programmer.svg": 167,
	"./projects_image.svg": 168,
	"./reach.jpeg": 169,
	"./reach.png": 170,
	"./red_cross.png": 171,
	"./suiis.png": 172,
	"./suls.png": 173,
	"./syncs.png": 174,
	"./talksCardBack.svg": 175,
	"./talksCardBackAlt.svg": 176,
	"./tiktok_logo.png": 177,
	"./tongyu-headshot.jpg": 178,
	"./ui_ux_design.svg": 179,
	"./usyd.png": 180,
	"./usyd_logo.png": 181,
	"./usyd_logo2.png": 182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45;